import { useMemo } from 'react';

import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';
import { fg } from '@atlaskit/platform-feature-flags/fg';

import { isAnswerUiPartsEnabled } from '../utils/is-answer-ui-parts-enabled';

export type RovoChatCapability =
	| 'ask-question-enabled'
	| 'inline_lumina_enabled'
	| 'answer_ui_parts_v1'
	| 'tool_resumption_enabled'
	| 'actionable-follow-ups'
	| 'actionable-follow-ups-stacked'
	| 'scheduled-chat-follow-up'
	| 'interaction-conclusion-v1';

export const useRovoChatCapabilities = (): RovoChatCapability[] => {
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const capabilities = useMemo(
		() => [
			'ask-question-enabled' as const,
			'interaction-conclusion-v1' as const,
			...(fg('rovo_chat_enable_inline_lumina') ? (['inline_lumina_enabled'] as const) : []),
			// Not in the service-level GATED_CAPABILITIES, which would opt in callers that
			// don't handle typed Answer UI events.
			...(isAnswerUiPartsEnabled() ? (['answer_ui_parts_v1'] as const) : []),
			'tool_resumption_enabled' as const,
			'actionable-follow-ups-stacked' as const,
			...(isExperimentEnabled('rovo_chat_scheduled_chat_follow_up')
				? (['scheduled-chat-follow-up'] as const)
				: []),
		],
		// Feature gates and experiment assignments are static during the chat session.
		[],
	);
	return capabilities;
};
